<template>
    <div class="formgrid grid p-fluid">
        <i class="fa fa-bars fa-lg icon-button ml-1 text-primary" title="Metas" @click.stop="abrirModal()">
        </i>
        <b-modal size="xl" v-model="mostrarModal" no-close-on-backdrop no-enforce-focus
            @show="preencherModalEntrega()">
            <div slot="modal-title">Meta de Entrega - Convênio: {{ entrega.idConvenio }}</div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="24" md="12">
                        <b-form-group>
                            <label class="required">Nome da Meta de Entrega</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="nomeMetaEntrega">
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row >
                    <b-col >
                        <b-form-group class="float-right">
                            <b-button variant="success" :disabled="$v.$invalid" @click="inserirMetaEntrega()">
                                Inserir Meta de Entrega
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
            <b-card no-body>
                <b-card-header>
                    <span class="h5"> Metas Da Entrega </span>
                </b-card-header>
                <b-card-body>
                    <app-tabela :itens="metasEntrega" :campos="campos" :itensPorPagina="itensPorPagina"
                        :bordered="false" :small="false">
                        <!-- <template slot="botoes">
                            <b-button-group class="float-right">
                                <b-button variant="success"  :disabled="$v.$invalid"
                                    @click="inserirMetaEntrega()" class="ml-1">
                                    Inserir Meta de Entrega
                                </b-button>
                            </b-button-group>
                        </template> -->

                        <template slot="acoes" slot-scope="data">
                            <span class="text-secondary float-left mr-1">
                                <b-button-group class="float-right">
                                    <documentos-meta-entrega :dataServicos="dataServicos" :metaEntrega="data"
                                        @atualizarLista="atualizarEntregas()">
                                    </documentos-meta-entrega>
                                    <!-- <btn-cancelar-meta :entrega="entrega" :meta="data" :dataServicos="dataServicos"
                                        @fecharModal="fecharModal()"
                                        @abrirModal="abrirModal()">
                                    </btn-cancelar-meta> -->

                                </b-button-group>
                            </span>
                        </template>
                    </app-tabela>
                </b-card-body>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import DocumentosMetaEntrega from '../DocumentosMetaEntrega'
import BtnCancelarMeta from './BtnCancelarMeta'
import BtnInserirMeta from './BtnInserirMeta'

export default {
    components: {
        BtnInserirMeta,
        BtnCancelarMeta,
        DocumentosMetaEntrega,
    },

    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteInserirMetas: {
            type: Boolean,
            default: false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: false
        }
    },

    validations: {
        nomeMetaEntrega: { required }

    },

    data() {
        return {
            nomeMetaEntrega: null,
            mostrarModal: false,
            totalRealizado: 0,
            metasEntrega: [],
            erros: [],
            itensPorPagina: 5,
            metas: [],
            selectedTipo: 0,
            campos: [
                {
                    key: 'nomeMetaEntrega',
                    label: 'Nome da Meta',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },
    computed: {

    },
    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.erros = [];
            this.limparCampos();
            this.erros = [];
            if (this.entrega.idEntrega) {
                this.obterMetasEntrega(this.entrega.idEntrega);
            }

        },
        obterMetasEntrega(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterMetasEntrega(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.metasEntrega = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )

        },
        preencherModalEntrega() {
            if (this.entrega != null) {
                this.tipoRealizacao = "CON"
                this.MetaEntregaDto=this.entrega
            }
        },
        fecharModal() {
            this.mostrarModal = false
            this.MetaEntregaDto = null
        },
        limparCampos() {
            this.nomeMetaEntrega=null
        },
        inserirMetaEntrega() {
            this.$store.dispatch('addRequest')
            let MetaEntregaDto = {
                nomeMetaEntrega: this.nomeMetaEntrega,
                idConvenio: this.entrega.idConvenio,
                idAcaoPlanoTrabalho: this.entrega.idAcaoPlanoTrabalho,
                idEntrega: this.entrega.idEntrega
            }
            this.dataServicos.inserirMetaEntrega(MetaEntregaDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Meta de Entrega inserida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterMetasEntrega(this.entrega.idEntrega);
                        this.$emit('atualizarLista')
                        //  this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.limparCampos();
        },
    }
}
</script>
